import { Route, Redirect } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";

const PrivateRoute = ({ children, ...rest }) => {
    const { code, slug } = useContext(AuthContext);
    return <Route {...rest}>{!code ? <Redirect to={`/login/${slug}`} /> : children}</Route>;
};

export default PrivateRoute;